import React, { Component } from 'react';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { View, Text } from 'react-native';
import { ProcessTypes } from 'fitbeat.gym-core';

import { Logger, i18n, getSlotTime, getMomentFormat } from '../../utils';
import { confirmRemoveWaitlistEntry, getNextBookingStep, setWaitlistEntry } from '../actions';
import { styles as sharedStyles } from './Styles';
import { ConfirmAction } from '../components';
import { removeFromWaitingListToast, showToastMessage } from '../../ui';

class ConfirmCancelWaitlistEntry extends Component {
  static getTitle = () => <></>;
  static getSubtitle = () => <></>;

  state = {
    isLoading: false,
    error: null,
  }

  setIsLoading = (isLoading) => {
    this.setState({ isLoading });
  }

  setError = (error) => {
    this.setState({ error });
  }

  clearError = () => {
    this.setError(null);
  }

  removeFromWaitingList = async () => {
    const {
      waitlistEntry,
      userProfile,
      getNextBookingStep,
      waitingListServiceClient: { removeFromWaitingList },
    } = this.props;

    try {
      this.clearError();
      this.setIsLoading(true);
      await removeFromWaitingList(waitlistEntry);
      getNextBookingStep(userProfile, ProcessTypes.WaitlistCancelled);
      this.props.confirmRemoveWaitlistEntry(waitlistEntry);
      this.props.showToastMessage(removeFromWaitingListToast(moment(waitlistEntry.timeSlot.startTime).format('dddd, Do MMMM')));
    } catch (error) {
      console.log('error', error);
      this.setError(error);
      Logger.notify(error);
    } finally {
      this.setIsLoading(false);
    }
  }

  dontRemoveFromWaitlist = () => {
    const { userProfile, getNextBookingStep } = this.props;
    getNextBookingStep(userProfile, ProcessTypes.Start);
  }

  render() {
    const { t } = this.props;
    const { isLoading, error } = this.state;

    const confirmationText = t('cancelWaitlistConfirmation');
    return (
      <View style={sharedStyles.containerNoPadding}>
        <ConfirmAction
          title={t('removeFromWaitlist')}
          subtitle={confirmationText}
          leftButtonText={t('yesCancelWaitlist')}
          rightButtonText={t('no')}
          leftButtonPress={this.removeFromWaitingList}
          rightButtonPress={this.dontRemoveFromWaitlist}
          isLoading={isLoading}
          error={error}
          leftButtonOverrideStyles={sharedStyles.leftButtonOverideStyle}
          rightButtonOverrideStyles={sharedStyles.rightButtonOverideStyle}
        />
      </View>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    workoutSession: state.bookings.bookingWizard.workoutSession,
    waitlistEntry: state.bookings.bookingWizard.waitlistEntry,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    showToastMessage: (toast) => dispatch(showToastMessage(toast)),
    getNextBookingStep: (userProfile, processType) => dispatch(getNextBookingStep(userProfile, processType)),
    setWaitlistEntry: (waitlistEntry) => dispatch(setWaitlistEntry(waitlistEntry)),
    confirmRemoveWaitlistEntry: (waitlistEntry) => dispatch(confirmRemoveWaitlistEntry(waitlistEntry))
  };
};

ConfirmCancelWaitlistEntry = connect(mapStateToProps, mapDispatchToProps)(ConfirmCancelWaitlistEntry);
export default translate(['bookings'], { wait: true })(ConfirmCancelWaitlistEntry);
